exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".footer{width:100%;height:398px;background:#fff;background-size:100% 398px;position:relative;text-align:center}.footer .title{padding-top:80px;font-family:PingFangSC,PingFang SC;font-weight:700;font-size:34px;color:#333;line-height:34px;text-align:center;font-style:normal}.footer .btn-box{width:100%;height:60px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center}.footer .btn-box .btn{margin-top:80px;width:164px;height:60px;background:#10d294;font-size:16px;color:#fff;line-height:60px;cursor:pointer;border-radius:5px}.footer .btn-box .btn,.footer .footer-copyright-box{font-family:PingFangSC,PingFang SC;font-weight:700;text-align:center;font-style:normal}.footer .footer-copyright-box{width:100%;height:94px;position:absolute;bottom:0;left:0;font-size:14px;color:#666;line-height:94px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-02ce75de","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/footer-menu.vue
// module id = 148
// module chunks = 1